import React, {Component} from 'react';
import PropTypes from 'prop-types';

class FormattedRate extends Component {

    render() {
        const {rate} = this.props;

        return (
            <span>
                {new Intl.NumberFormat('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(rate)
                } %
            </span>
        );
    }
}

FormattedRate.propTypes = {
    rate: PropTypes.number.isRequired
};

export default (FormattedRate);
